
























import { Component, Vue } from 'vue-property-decorator'
import { mapActions } from 'vuex'

@Component({
  computed: {
    version(): string {
      return process.env.TABVN_VERSION || 'RELEASE'
    },
  },
  methods: {
    ...mapActions(['M_INIT']),
  },
})
export default class StartMenu extends Vue {
  isSignedIn: boolean = false
  isLoading: boolean = false
  isPure: boolean = true

  mounted(): void {
    this.isLoading = true;
    (this as any).$gapi._load().then((api: any) => {
      // TODO: will need to update
      (this as any).$gapi.isSignedIn()
        .then((result: boolean) => {
          this.isSignedIn = result
          this.isLoading = false
        })
    })
  }

  handleSignIn(): void {
    if (this.isLoading) { return }

    this.isPure = false
    this.isLoading = true;
    (this as any).$gapi.isSignedIn()
      .then((result: boolean) => {
        this.isSignedIn = result
        if (!result) {
          return (this as any).$gapi.signIn()
        } else {
          return (this as any).$gapi.currentUser()
        }
      }).then((user: any) => {
        if (user) {
          this.isSignedIn = true
          this.isLoading = false
        }
      }).catch((err: Error) => {
        // TODO: add some other error handling
        // to display to the user
        console.error(err)
        this.isLoading = false
      })
  }

  handleNewGame(): void {
    if (this.isLoading) { return }

    this.isPure = false
    this.isLoading = true

    this.$store.commit('UPDATE_LOADING', true)

    // Check if the init script is downloaded
    if (!this.$store.state.scripts.hasInit) {
      (this as any).M_INIT((this as any).$gapi).then((result: any) => {
        this.isLoading = false
        this.goNewGame()
      })
    } else {
       this.goNewGame()
    }

    this.isLoading = false
  }

  goNewGame(): void {
    // this.$store.commit('UPDATE_LOADING', true)
    this.$store.commit('SET_CURRENT_FILE', this.$store.state.engine.initFile)
    this.$store.commit('SET_CURRENT_LINE', 0)
    setTimeout(() => {
      this.$router.push('/player')
      // replace with script loading promise
      setTimeout(() => {
        this.$store.commit('UPDATE_LOADING', false)
      }, 1000)
    }, 1000)
  }
}
